export default __webpack_public_path__ + "static/media/sms.d4be62cf.svg";